import { getAnalyticsConfig } from '@ynap/config-state'
import { getShippingOptions, getCurrentShippingOption, getCurrentOrderShippingInfo } from '@ynap/cart-state'
import getCart from './getCart'
import { createCombinedSelector } from '../utils/selectorUtils'
import { StoreState } from 'app/state/types'
import { FetchCartError } from '../reducers/fetchCartError'
import { Messages } from 'app/types/common-types'

export default createCombinedSelector({
    name: 'getShippingOptionsStep',
    state: ['config', 'locale', 'cart', 'isFetchingCart', 'fetchCartError', 'deviceType', 'crisisMessages', 'jitMessages'],
    props: ['messages'],
    fn: getShippingOptionsStepInternal,
})

interface State extends StoreState {
    isFetchingCart: boolean
    fetchCartError: FetchCartError
}

type Props = {
    messages: Messages
}

export function getShippingOptionsStepInternal(state: State, props: Props) {
    const { isFetchingCart, fetchCartError, config, crisisMessages, jitMessages } = state
    const [shippingOptions, jitShippingOptions] = getShippingOptions(state, props)
    const [currentShippingOption, currentShippingOptionJit] = getCurrentShippingOption(state, props)
    const [currentOrderShippingInfo, currentOrderShippingInfoJit] = getCurrentOrderShippingInfo(state)
    const cart = getCart(state, props)

    const {
        hasJITItems,
        lineItems,
        remoteItems,
        localItems,
        totals,
        genericTotal,
        x_exchangeRate,
        basePrice,
        basePriceGBP,
        itemSubtotal,
        transactionTotal,
        checkoutAnalytics,
        hasShippingMethodChanged,
        isPostSplit,
    } = cart

    const loading = isFetchingCart
    const error = fetchCartError || !shippingOptions || !shippingOptions.length
    const completed = shippingOptions ? !!currentShippingOption : undefined
    const signatureNotification = config?.head?.flags?.signatureNotification
    const signatureRequired =
        currentOrderShippingInfo?.currentSignatureRequired ||
        currentOrderShippingInfoJit?.currentSignatureRequired ||
        currentShippingOption?.defaultSignatureRequired ||
        currentShippingOptionJit?.defaultSignatureRequired ||
        shippingOptions?.[0]?.defaultSignatureRequired ||
        jitShippingOptions?.[0]?.defaultSignatureRequired

    return {
        config,
        shippingOptions,
        jitShippingOptions,
        currentShippingOption,
        currentShippingOptionJit,
        lineItems,
        remoteItems,
        localItems,
        totals,
        loading,
        error,
        completed,
        currentOrderShippingInfo,
        currentOrderShippingInfoJit,
        analytics: getAnalyticsConfig(state),
        genericTotal,
        signatureNotification,
        x_exchangeRate,
        basePrice,
        basePriceGBP,
        itemSubtotal,
        transactionTotal,
        checkoutAnalytics,
        hasJITItems,
        crisisMessages,
        jitMessages,
        hasShippingMethodChanged,
        isPostSplit,
        signatureRequired,
    }
}
